import { render, staticRenderFns } from "./LightGal.vue?vue&type=template&id=ce37a490"
import script from "./LightGal.vue?vue&type=script&lang=js"
export * from "./LightGal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports